import Cotizaciones from "../views/modulos/pedidos/List.vue";
import Pedidos from "../views/modulos/pedidos/List.vue";
import PedidosForm from "../views/modulos/pedidos/Form.vue";
import PedidosFormChecks from "../views/modulos/pedidos/FormChecks.vue";
import ListGarantias from "../views/modulos/garantias/List.vue";

const VarRutasPedidos=[
    {
        path: '/cotizaciones',
        name: 'cotizaciones',
        component: Cotizaciones,
        props: true
    },
    {
        path: '/pedidos',
        name: 'pedidos',
        component: Pedidos,
        props: true
    },
    {
        path: '/formpedidos',
        name: 'formpedidos',
        component: PedidosForm,
        props: true
    },

    {
        path: '/formpedidoschecks',
        name: 'formpedidoschecks',
        component: PedidosFormChecks,
        props: true
    },
    {
        path: '/garantias',
        name: 'garantias',
        component: ListGarantias,
        props: true
    }
   
];
export default {
    VarRutasPedidos,
}